import { useEffect, useState } from 'react';
import {
  useApi,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createFormField } from '@backstage/plugin-scaffolder-react/alpha';

type Compartment = { id: string; name: string };

export function OciCompartmentPickerComponent({
  onChange,
  rawErrors,
  formData,
  formContext,
}: any) {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const region: string = (formContext as any)?.formData?.region ?? '';
  const [compartments, setCompartments] = useState<Compartment[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!region) {
      setCompartments([]);
      onChange(undefined as any);
      return;
    }
    setLoading(true);
    setError('');
    discoveryApi.getBaseUrl('infrastructure').then(baseUrl => {
      fetchApi
        .fetch(
          `${baseUrl}/oci/compartments?region=${encodeURIComponent(region)}`,
        )
        .then(r => r.json())
        .then(data => {
          if (data.error) {
            setError(
              typeof data.error === 'string'
                ? data.error
                : data.error?.message ?? 'Failed to load compartments',
            );
          } else {
            setCompartments(data.compartments ?? []);
            onChange(undefined as any);
          }
        })
        .catch(() => setError('Failed to load compartments'))
        .finally(() => setLoading(false));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region]);

  if (loading) return <CircularProgress size={20} />;

  return (
    <FormControl fullWidth error={!!rawErrors?.length || !!error}>
      <InputLabel>OCI Compartment</InputLabel>
      <Select
        value={formData ?? ''}
        onChange={e => onChange(e.target.value as string)}
        disabled={!region}
      >
        {!region && (
          <MenuItem value="" disabled>
            Select a region first
          </MenuItem>
        )}
        {compartments.map(c => (
          <MenuItem key={c.id} value={c.id}>
            {c.name}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}

export const OciCompartmentPickerField = createFormField({
  name: 'OciCompartmentPicker',
  component: OciCompartmentPickerComponent,
});
